import uuid from 'uuid/v4';

import { ACTIONS } from '@~/actions/client-event-notification';

const initialState = {
  clientEvents: [],
  batchedClientEvents: {},
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.RECORD_CLIENT_EVENT: {
      const {
        clientEventType,
        clientEventData,
        attributes = {},
        pubnubMessageAttributes = {},
      } = payload;

      return {
        ...state,
        clientEvents: [
          ...state.clientEvents,
          {
            eventId: uuid(),
            eventTime: Date.now(),
            clientEventType,
            clientEventData: {
              pubnubMessageAttributes,
              attributes,
              ...clientEventData,
            },
          },
        ],
      };
    }
    case ACTIONS.CLEAR_CLIENT_EVENTS: {
      const { eventIds } = payload;

      return {
        ...state,
        clientEvents: state.clientEvents.filter(
          event => !eventIds.includes(event.eventId),
        ),
      };
    }
    default:
      return state;
  }
}
